/**
 * A signed PUT with progress — the one `XMLHttpRequest` in this bundle.
 *
 * Moved here from `Albums.tsx` when the product photographs (B7) needed the
 * same request, so it stays *one* rather than becoming two that drift.
 *
 * `fetch` has no upload progress event. On a dock's wifi a hundred-file batch
 * takes minutes, and minutes with no feedback is the state a photographer force
 * quits out of. `ApiClient` cannot carry it either: it JSON-stringifies every
 * body and zod-parses every response, and this request sends image bytes to a
 * different origin and expects none. The header must match what the URL was
 * signed for or Google refuses it, which is why the type is passed rather than
 * left to the browser.
 */
export function putWithProgress(
  url: string,
  file: File,
  contentType: string,
  onProgress: (percent: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('PUT', url, true);
    request.setRequestHeader('Content-Type', contentType);
    request.upload.onprogress = (event) => {
      if (event.lengthComputable) onProgress(Math.round((event.loaded / event.total) * 100));
    };
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) resolve();
      else reject(new Error(`upload failed: ${String(request.status)}`));
    };
    request.onerror = () => reject(new Error('upload failed'));
    request.send(file);
  });
}
